import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Label,
  Form,
  FormFeedback,
  Input,
  Alert,
  UncontrolledAlert,
} from "reactstrap";

// Redux
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
// actions
import { loginUser, apiError } from "../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";
// import images
import logoSm from "../../assets/images/logo-sm.png";
import { login } from "store/features/auth/authSlice";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import { validationSchema } from "schemas/userInfoValidation";
import { toast } from "sonner";
import { useUserLoginMutation } from "store/features/auth/authManagementApi";
import getToken from "utils/getToken";
import { setUserCRM } from "store/features/users/userSlice";

const Login = () => {
  const [makeLogin, { isLoading }] = useUserLoginMutation();
  const [errorMessage, setErrorMessage] = useState(null);
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();
  const onDismiss = () => setVisible(false);
  const dispatch = useDispatch();
  const submit = async data => {
    const result = await makeLogin(data);

    console.log("result", result);
    if (result?.data?.id) {
      // Check account status before allowing login
      if (result.data.account_status === false) {
        setErrorMessage("Your account is disabled.");
        setVisible(true);
        return;
      }

      toast.success("Login successful");
      const token = await getToken(result.data);
      dispatch(
        login({
          id: result.data.id,
          personal_email: result.data.personal_email,
          token,
          role: result?.data?.role,
          nickname: result?.data?.nickname,
          address: result?.data?.address,
          image: result?.data?.image
        })
      );

      dispatch(
        setUserCRM({
          default_crm: result.data.default_crm,
          crm_permissions: result.data.crm_permissions,
        })
      );

      if (result?.data?.role == "super_admin" || result?.data?.role == "admin") {

        // navigate("/admin-dashboard");
        navigate("/dashboard");
      } else {
        navigate("/dashboard");

      }
    } else if (result?.error) {
      setErrorMessage("Invalid User Information");
      setVisible(true);
    } else {
      setErrorMessage("An unexpected error occurred");
      setVisible(true);
    }
  };

  document.title = "Login | Qwik IT Services";
  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={4}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20">Welcome Back !</h5>
                    <p className="text-white-50">
                      Sign in to continue to Qwik IT Services.
                    </p>
                    <Link to="/" className="logo logo-admin">
                      <img src={logoSm} height="50" alt="logo" />
                    </Link>
                  </div>
                </div>

                <CardBody className="p-4">
                  <div className="p-3">
                    {errorMessage && (
                      <Alert
                        color="danger"
                        className={`mt-4 ${!visible ? "d-none" : ""}`}
                        fade={true} // enable fade
                        isOpen={visible}
                        toggle={onDismiss}
                        transition={{ timeout: 100 }} // fade duration
                      >
                        {errorMessage}
                      </Alert>
                    )}

                    <QwikForm
                      onSubmit={submit}
                      resolver={yupResolver(validationSchema)}
                      className="mt-4"
                    >
                      <div className="mb-3">
                        <QwikInput
                          name="email"
                          label="Email"
                          placeholder="Enter Email"
                          type="email"
                          className="form-control"
                        />
                      </div>

                      <div className="mb-3">
                        <QwikInput
                          name="password"
                          label="Password"
                          placeholder="Enter Password"
                          type="password"
                        />
                      </div>

                      <div className="mb-3 row">
                        <div className="col-sm-6">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customControlInline"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customControlInline"
                            >
                              Remember me
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-6 text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                            disabled={isLoading}
                          >
                            {isLoading ? "Logging in..." : "Log In"}
                          </button>
                        </div>
                      </div>

                      <div className="mt-2 mb-0 row">
                        <div className="col-12 mt-4">
                          <Link to="/forgot-password">
                            <i className="mdi mdi-lock"></i> Forgot your
                            password?
                          </Link>
                        </div>
                      </div>
                    </QwikForm>
                  </div>
                </CardBody>
              </Card>
              {/* <div className="mt-5 text-center">
                <p>
                  Don&#39;t have an account ?{" "}
                  <Link to="/register" className="fw-medium text-primary">
                    {" "}
                    Signup now{" "}
                  </Link>{" "}
                </p>
                <p>© {new Date().getFullYear()} By Qwik IT Services</p>
              </div> */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  const { error } = state.Login;
  return { error };
};

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
);

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
};
